import { hasArchivedItems } from "web_myplann/Portfolio/Helpers/hasArchivedItems";
import { useAvailableCategoriesByContractState } from "web_myplann/Portfolio/Hooks/useAvailableCategoriesByContractState";

export const useHasArchivedItems = (): boolean => {
	const availableByContractState = useAvailableCategoriesByContractState();

	return hasArchivedItems(availableByContractState);
};
